import React from 'react'

import { StockCellContent } from '@components/common/StockCellContent'
import type { DropdownItemProps } from '@fourthwall/components'
import { Colors, Dropdown, ToolbarButton } from '@fourthwall/components'
import { DotsHorizontalIcon } from '@fourthwall/icons'
import type { Product } from '@modules/Dashboard/Products/types'

import { ProductThumbnailWithTooltip } from '../../../../components/ProductThumbnailWithTooltip'
import { ProductStatus } from '../../../ProductStatus/ProductStatus'
import { ProductName } from '../ProductName/ProductName'
import * as S from './ProductListItem.styled'

export type ProductListItemProps = {
  product: Product
  dropdownItems: Array<
    DropdownItemProps & { enabled?: boolean; onClick: (product: Product) => void }
  >
}

export const ProductListItem = ({ product, dropdownItems }: ProductListItemProps) => {
  return (
    <S.Container>
      <S.ProductItemDetails>
        <ProductThumbnailWithTooltip product={product} size="extraLarge" />
        <S.ProductDetails>
          <S.ProductName>
            <ProductName product={{ name: product.name, type: product.type }} />
          </S.ProductName>
          <S.ProductStatus>
            <ProductStatus status={product.status} soldOut={product.markedAsSoldOut} />
          </S.ProductStatus>
          <S.ProductInventory>
            <StockCellContent
              showFullLabel
              type={product.stock.type}
              quantity={product.stock.quantity}
            />
            {product.markedAsSoldOut && <div>Marked as sold out</div>}
          </S.ProductInventory>
        </S.ProductDetails>
      </S.ProductItemDetails>
      <S.ProductItemActions>
        <Dropdown
          content={
            <>
              {dropdownItems
                .filter(({ enabled = true }) => enabled)
                .map((dropdownItem) => (
                  <Dropdown.Item
                    label={dropdownItem.label}
                    onClick={(e: React.MouseEvent) => {
                      e.preventDefault()
                      dropdownItem.onClick?.(product)
                    }}
                  />
                ))}
            </>
          }
        >
          <ToolbarButton icon={DotsHorizontalIcon} color={Colors.GS600} />
        </Dropdown>
      </S.ProductItemActions>
    </S.Container>
  )
}
